import Vue from "vue";
import Router from "vue-router";

import Layout from "@/components/Layout/Layout";

// Pages
import Dashboard from "@/pages/Dashboard/Dashboard";
import Typography from "@/pages/Typography/Typography";
import Tables from "@/pages/Tables/Basic";
import Notifications from "@/pages/Notifications/Notifications";
import Icons from "@/pages/Icons/Icons";
import Charts from "@/pages/Charts/Charts";
import Maps from "@/pages/Maps/Google";
import Error from "@/pages/Error/Error";
import Login from "@/pages/Login/Login";
import CreateOrder from "@/pages/Order/CreateOrder";
import SummaryOrder from "@/pages/Order/SummaryOrder";
import Manual from "@/pages/Manual/Manual";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [

    {
      path: "/login",
      name: "Login",
      component: Login,
    },

    {
      path: "/",
      redirect: "/dashboard",
      name: "Layout",
      component: Layout,
      children: [
        {
          path: "dashboard",
          name: "Dashboard",
          component: Dashboard,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "Order/CreateOrder",
          name: "CreateOrder",
          component: CreateOrder,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "Order/SummaryOrder",
          name: "SummartOrder",
          component: SummaryOrder,
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: "Manual/Manual",
          name: "Manual",
          component: Manual,    

        }

        /*
        {
          path: "typography",
          name: "Typography",
          component: Typography,
        },
        {
          path: "tables",
          name: "Tables",
          component: Tables,
        },
        {
          path: "notifications",
          name: "Notifications",
          component: Notifications,
        },
        {
          path: "icons",
          name: "Icons",
          component: Icons,
        },
        {
          path: "charts",
          name: "Charts",
          component: Charts,
        },
        {
          path: "maps",
          name: "Maps",
          component: Maps,
        },
        */
      ],
    },
   
  ],
});


export default router;


router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
     if (localStorage.getItem('authenticated') == 'true')  {
      next();
      return;
    }else{
      next({
        path: '/login',
        params: { nextUrl: to.fullPath }
      })
    }
    //next("/login");
  } else {
    next();
  }
});

